<template>
  <div class="modal fade edit-modal" id="editBusinessModal" tabindex="-1" aria-labelledby="editBusinessModalLabel" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white">
          <h5 class="modal-title text-white">
            <i class="bx bx-edit me-2"></i>Edit Business Details
          </h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <div v-if="loading" class="text-center py-5">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <p class="mt-3">Loading business details...</p>
          </div>

          <form v-else @submit.prevent="updateBusiness">
            <div class="row">
              <!-- Business Information -->
              <div class="col-12">
                <h6 class="text-primary mb-3">
                  <i class="bx bx-briefcase me-2"></i>Business Information
                </h6>
              </div>

              <div class="col-md-6 mb-3">
                <label class="form-label">Business Name <span class="text-danger">*</span></label>
                <input v-model="formData.businessName" type="text" class="form-control" required>
              </div>

              <div class="col-md-6 mb-3">
                <label class="form-label">Business ID</label>
                <input v-model="formData.businessID" type="text" class="form-control" readonly>
              </div>

              <div class="col-md-6 mb-3">
                <label class="form-label">Business Description</label>
                <input v-model="formData.businessDes" type="text" class="form-control">
              </div>

              <div class="col-md-6 mb-3">
                <label class="form-label">Plot Number</label>
                <input v-model="formData.plotNumber" type="text" class="form-control">
              </div>

              <div class="col-md-6 mb-3">
                <label class="form-label">KRA PIN</label>
                <input v-model="formData.kraPin" type="text" class="form-control">
              </div>

              <div class="col-md-6 mb-3">
                <label class="form-label">Business Phone</label>
                <input v-model="formData.businessPhone" type="text" class="form-control">
              </div>

              <div class="col-md-6 mb-3">
                <label class="form-label">Business Email</label>
                <input v-model="formData.businessEmail" type="email" class="form-control">
              </div>

              <!-- Owner Information -->
              <div class="col-12 mt-4">
                <h6 class="text-primary mb-3">
                  <i class="bx bx-user me-2"></i>Owner Information
                </h6>
              </div>

              <div class="col-md-6 mb-3">
                <label class="form-label">Full Names <span class="text-danger">*</span></label>
                <input v-model="formData.fullNames" type="text" class="form-control" required>
              </div>

              <div class="col-md-6 mb-3">
                <label class="form-label">ID/Passport Number <span class="text-danger">*</span></label>
                <input v-model="formData.ownerID" type="text" class="form-control" required>
              </div>

              <div class="col-md-6 mb-3">
                <label class="form-label">Owner Phone <span class="text-danger">*</span></label>
                <input v-model="formData.ownerPhone" type="text" class="form-control" required>
              </div>

              <div class="col-md-6 mb-3">
                <label class="form-label">Owner Email</label>
                <input v-model="formData.ownerEmail" type="email" class="form-control">
              </div>

              <div class="col-md-6 mb-3">
                <label class="form-label">Postal Address</label>
                <input v-model="formData.postalAddress" type="text" class="form-control">
              </div>

              <!-- Location Information -->
              <div class="col-12 mt-4">
                <h6 class="text-primary mb-3">
                  <i class="bx bx-map me-2"></i>Location Information
                </h6>
              </div>

              <div class="col-md-6 mb-3">
                <label class="form-label">Physical Address</label>
                <input v-model="formData.physicalAddress" type="text" class="form-control">
              </div>

              <div class="col-md-6 mb-3">
                <label class="form-label">Building Name</label>
                <input v-model="formData.buildingName" type="text" class="form-control">
              </div>

              <div class="col-md-6 mb-3">
                <label class="form-label">Floor Number</label>
                <input v-model="formData.floorNo" type="text" class="form-control">
              </div>

              <div class="col-md-6 mb-3">
                <label class="form-label">Room/Stall Number</label>
                <input v-model="formData.roomNo" type="text" class="form-control">
              </div>

              <div class="col-md-6 mb-3">
                <label class="form-label">Sub County</label>
                <select v-model="formData.subCountyID" @change="loadWards" class="form-control">
                  <option value="">Select Sub County</option>
                  <option v-for="(item, index) in subCounties" :key="index" :value="item.subCountyID">
                    {{ item.subCountyName }}
                  </option>
                </select>
              </div>

              <div class="col-md-6 mb-3">
                <label class="form-label">Ward</label>
                <select v-model="formData.wardID" class="form-control">
                  <option value="">Select Ward</option>
                  <option v-for="(item, index) in wards" :key="index" :value="item.wardID">
                    {{ item.wardName }}
                  </option>
                </select>
              </div>
            </div>

            <div v-if="errorMessage" class="alert alert-danger mt-3">
              <i class="bx bx-error me-2"></i>{{ errorMessage }}
            </div>

            <div v-if="successMessage" class="alert alert-success mt-3">
              <i class="bx bx-check-circle me-2"></i>{{ successMessage }}
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" :disabled="saving">
            Cancel
          </button>
          <button type="button" @click="updateBusiness" class="btn btn-primary" :disabled="saving">
            <span v-if="!saving">
              <i class="bx bx-save me-2"></i>Save Changes
            </span>
            <span v-else>
              <span class="spinner-border spinner-border-sm me-2"></span>
              Saving...
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { execute, authUrl, trade } from "@/api";

export default {
  name: "EditBusinessModal",
  props: {
    businessID: String,
    billNo: String,
    feeID: String
  },
  data() {
    return {
      loading: false,
      saving: false,
      errorMessage: '',
      successMessage: '',
      formData: {
        businessID: '',
        businessName: '',
        businessDes: '',
        plotNumber: '',
        kraPin: '',
        businessPhone: '',
        businessEmail: '',
        fullNames: '',
        ownerID: '',
        ownerPhone: '',
        ownerEmail: '',
        postalAddress: '',
        physicalAddress: '',
        buildingName: '',
        floorNo: '',
        roomNo: '',
        subCountyID: '',
        subCountyName: '',
        wardID: '',
        wardName: '',
        year: '',
        feeId: ''
      },
      subCounties: [],
      wards: []
    };
  },
  methods: {
    async loadBusinessDetails() {
      if (!this.businessID || !this.billNo) return;

      this.loading = true;
      this.errorMessage = '';

      try {
        const data = new FormData();
        data.append("function", "getBusinessDetails");
        data.append("billNo", this.billNo);
        data.append("sessionNames", sessionStorage.getItem("sessionNames"));
        data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

        const res = await execute(data, trade);
        if (res.data.success) {
          const business = res.data.data.business || {};
          const entries = res.data.data.entries || {};

          this.formData = {
            businessID: business.businessID || '',
            businessName: business.businessName || '',
            businessDes: business.businessDes || '',
            plotNumber: business.plotNumber || '',
            kraPin: business.kraPin || '',
            businessPhone: business.businessPhone || '',
            businessEmail: business.businessEmail || '',
            fullNames: business.fullNames || '',
            ownerID: business.ownerID || '',
            ownerPhone: business.ownerPhone || '',
            ownerEmail: business.ownerEmail || '',
            postalAddress: business.postalAddress || '',
            physicalAddress: business.physicalAddress || '',
            buildingName: business.buildingName || '',
            floorNo: business.floorNo || '',
            roomNo: business.roomNo || '',
            subCountyID: business.subCountyID || '',
            subCountyName: business.subCountyName || '',
            wardID: business.wardID || '',
            wardName: business.wardName || '',
            year: entries.fiscalYear || entries.year || new Date().getFullYear().toString(),
            feeId: entries.feeID || this.feeID || ''
          };

          if (this.formData.subCountyID) {
            await this.loadWards();
          }
        } else {
          this.errorMessage = res.data.message || 'Failed to load business details';
        }
      } catch (error) {
        console.error("Error loading business details:", error);
        this.errorMessage = 'An error occurred while loading business details';
      } finally {
        this.loading = false;
      }
    },

    async loadSubCounties() {
      try {
        const data = new FormData();
        data.append("function", "getSubCounties");
        const res = await execute(data, authUrl);
        if (res.data.success) {
          this.subCounties = res.data.data.subCounties || [];
        }
      } catch (error) {
        console.error("Error loading sub-counties:", error);
      }
    },

    async loadWards() {
      if (!this.formData.subCountyID) {
        this.wards = [];
        return;
      }

      try {
        const data = new FormData();
        data.append("function", "getWards");
        data.append("subCountyID", this.formData.subCountyID);
        const res = await execute(data, authUrl);
        if (res.data.success) {
          this.wards = res.data.data.wards || [];

          // Update subCountyName when subCountyID changes
          const selectedSubCounty = this.subCounties.find(sc => sc.subCountyID === this.formData.subCountyID);
          if (selectedSubCounty) {
            this.formData.subCountyName = selectedSubCounty.subCountyName;
          }
        }
      } catch (error) {
        console.error("Error loading wards:", error);
      }
    },

    async updateBusiness() {
      this.saving = true;
      this.errorMessage = '';
      this.successMessage = '';

      try {
        // Update wardName based on selected wardID
        const selectedWard = this.wards.find(w => w.wardID === this.formData.wardID);
        if (selectedWard) {
          this.formData.wardName = selectedWard.wardName;
        }

        const data = new FormData();
        data.append("function", "updateBusiness");
        data.append("businessID", this.formData.businessID);
        data.append("billNo", this.billNo);
        data.append("businessName", this.formData.businessName);
        data.append("businessDes", this.formData.businessDes);
        data.append("plotNumber", this.formData.plotNumber);
        data.append("kraPin", this.formData.kraPin);
        data.append("businessPhone", this.formData.businessPhone);
        data.append("businessEmail", this.formData.businessEmail);
        data.append("fullNames", this.formData.fullNames);
        data.append("ownerID", this.formData.ownerID);
        data.append("ownerPhone", this.formData.ownerPhone);
        data.append("ownerEmail", this.formData.ownerEmail);
        data.append("postalAddress", this.formData.postalAddress);
        data.append("physicalAddress", this.formData.physicalAddress);
        data.append("buildingName", this.formData.buildingName);
        data.append("floorNo", this.formData.floorNo);
        data.append("roomNo", this.formData.roomNo);
        data.append("subCountyID", this.formData.subCountyID);
        data.append("subCountyName", this.formData.subCountyName);
        data.append("wardID", this.formData.wardID);
        data.append("wardName", this.formData.wardName);
        data.append("year", this.formData.year);
        data.append("feeId", this.formData.feeId);
        data.append("sessionNames", sessionStorage.getItem("sessionNames"));
        data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

        const res = await execute(data, trade);

        // Since the API uses exit(), it might not return a standard response
        // Check if there's an error or if the call was successful
        if (res.status === 200) {
          this.successMessage = 'Business details updated successfully!';
          setTimeout(() => {
            this.$emit('success', res.data);
            const modal = bootstrap.Modal.getInstance(document.getElementById('editBusinessModal'));
            if (modal) modal.hide();
          }, 1500);
        } else {
          this.errorMessage = res.data?.message || 'Failed to update business details';
        }
      } catch (error) {
        console.error("Error updating business:", error);
        this.errorMessage = 'An error occurred while updating business details';
      } finally {
        this.saving = false;
      }
    },

    initModal() {
      this.loadSubCounties();
      this.loadBusinessDetails();
    }
  },
  watch: {
    businessID(newVal) {
      if (newVal) {
        this.initModal();
      }
    }
  }
};
</script>

<style scoped>
.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}
</style>